
import { defineComponent, PropType } from "vue";

type AppliedFilter = {
  valueText?: string;
  value?: string | string[];
  clear?: () => void;
};

export default defineComponent({
  name: "AppliedFilters",
  props: {
    filters: {
      type: Object as PropType<Record<string, AppliedFilter>>,
      required: true,
    },
  },
  methods: {
    hasText(f: AppliedFilter) {
      return f && Object.keys(f).length > 0 && f.valueText !== "";
    },
    hasArrayOrValue(f: AppliedFilter) {
      return (
        f &&
        Object.keys(f).length > 0 &&
        f.valueText === "" &&
        f.value != null &&
        f.value !== ""
      );
    },
  },
});
